import axios from "axios";
import store from "@/store";

const axiosCms = axios.create({
    baseURL: process.env.VUE_APP_NONFICTION_BASE_API_URL
});


axiosCms.interceptors.request.use(
    config => {
        const token = store.state.User.token || Cookies.get("token");
        if (token) {
            config.headers = {
                ...config.headers,
                "Visitor-Token": token
            }
        }
        return config;
    },
    error => {
        return Promise.reject(error);
    },
);

axiosCms.interceptors.response.use(response => {
    // Do something with response data
    return response;
}, error => {
    // Only report errors on production
    if (process.env.NODE_ENV !== "development") {
        Sentry.captureException(error);
    }
    // Do something with response error
    return Promise.reject(error);
});


window.axiosCms = axiosCms;
export default axiosCms;
